import type { Store } from "schema/gen/es/chiikipoint/model/v2/model_pb";
import Warning from "~icons/material-symbols/warning-outline-rounded";
import { css } from "../../../styled-system/css";
import { t } from "../../libs/i18n";
import StoreBlock from "./components/store-block";

type RecentStoreConfirmModalProps = {
  store: Store;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function RecentStoreConfirmModal({
  store,
  onConfirm,
  onCancel,
}: RecentStoreConfirmModalProps) {
  return (
    <div
      className={css({
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(226, 226, 226, 0.5)",
        backdropFilter: "blur(4px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        px: "20px",
      })}
    >
      <div
        className={css({
          backgroundColor: "white",
          borderRadius: "16px",
          padding: "24px",
          width: "100%",
          maxWidth: "360px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
        })}
      >
        <div
          className={css({
            width: "56px",
            height: "56px",
            borderRadius: "999px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bg: "rgba(255, 237, 213, 1)",
            color: "rgba(234, 88, 12, 1)",
            fontSize: "32px",
          })}
        >
          <Warning />
        </div>

        <div
          className={css({
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            textAlign: "center",
          })}
        >
          <h2
            className={css({
              fontSize: "18px",
              fontWeight: "bold",
              color: "text.primary",
            })}
          >
            {t("店舗名をご確認ください")}
          </h2>
          <p
            className={css({
              fontSize: "14px",
              color: "text.secondary",
              lineHeight: "1.6",
            })}
          >
            {t("短時間に同じ店舗で支払いが行われました。")}
            <br />
            {t("この店舗で支払う場合のみ、続けてください。")}
          </p>
        </div>

        <div
          className={css({
            width: "100%",
            bg: "surface.secondary",
            borderRadius: "12px",
            p: "16px",
          })}
        >
          <StoreBlock store={store} size="compact" />
        </div>

        <button
          type="button"
          className={css({
            backgroundColor: "surface.accentPrimary",
            color: "white",
            padding: "12px",
            borderRadius: "8px",
            width: "100%",
            fontWeight: "bold",
            cursor: "pointer",
          })}
          onClick={onConfirm}
        >
          {t("この店舗で支払う")}
        </button>

        <button
          type="button"
          className={css({
            padding: "12px",
            borderRadius: "8px",
            width: "100%",
            fontWeight: "bold",
            cursor: "pointer",
            color: "text.primary",
          })}
          onClick={onCancel}
        >
          {t("キャンセル")}
        </button>
      </div>
    </div>
  );
}
